import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
   state: {
      userClaims: null,
      userEmail: "",
      appUser: null,
      announceHtml: "",
      appCode: process.env.VUE_APP_CODE,
      appointmentLink: "",
      hierarchies: [],
      hasAppointments: false,
      authInProgress: false,
      signature: "",
      agentName:"",
      cart: [],
      pendingReports: 0,
      checkPendingReports: false,
      internalAdmin: null,
   },
   getters: {
      pendingReports: state => {
         return state.pendingReports;
      },
      checkPendingReports: state => {
         return state.checkPendingReports;
      },
      userClaims: state => {
         if (state.userClaims == null) {
            var itm = localStorage.getItem("user-claims");
            if (itm) {
               state.userClaims = JSON.parse(itm);
            }
         }
         return state.userClaims;
      },
      userEmail: state => {
         return state.userEmail;
      },
      authInProgress: state => {
         return state.authInProgress;
      },
      appUser: state => {
         if (state.appUser == null) {
            var itm = localStorage.getItem("app-user");
            if (itm) {
               state.appUser = JSON.parse(itm);
            }
         }
         return state.appUser;
      },
      appointmentLink: state => {
         return state.appointmentLink;
      },
      appCode: state => {
         return state.appCode;
      },
      signature: state => {
         return state.signature;
      },
      agentName: state => {
         return state.agentName;
      },
      announceHtml: state => {
         return state.announceHtml;
      },
      hierarchies: state => {
         return state.hierarchies;
      },
      hasAppointments: state => {
         return state.hasAppointments;
      },
      cart: state => {
         return state.cart;
      },
      cartCount(state) {
         return state.cart.length
      },
      isInternalAdmin: (state, getters) => !!getters.internalAdmin,
      internalAdmin: state => {
         if (state.internalAdmin == null) {
            var itm = localStorage.getItem("internalAdmin");
            if (itm) {
               state.internalAdmin = JSON.parse(itm);
            }
         }

         return state.internalAdmin
      }
   },
   mutations: {
      updateCheckPendingReports(state, vlu) {
         state.checkPendingReports = vlu
      },
      updatePendingReports(state, vlu) {
         state.pendingReports = vlu
      },
      updateUserEmail(state, vlu) {
         state.userEmail = vlu;
      },
      updateAppUser(state, vlu) {
         localStorage.setItem("app-user", JSON.stringify(vlu));
         state.appUser = vlu;
      },
      updateAppointmentLink(state, vlu) {
         state.appointmentLink = vlu;
      },
      updateSignature(state, vlu) {
         state.signature = vlu;
      },
      updateAgentName(state,vlu) {
         state.agentName = vlu;
      },
      updateUserClaims(state, vlu) {
         localStorage.setItem("user-claims", JSON.stringify(vlu));
         state.userClaims = vlu;
      },
      updateAnnounce(state, vlu) {
         state.announceHtml = vlu;
      },
      updateHierarchies(state, vlu) {
         state.hierarchies = vlu;
      },
      updateHasAppointments(state, vlu) {
         state.hasAppointments = vlu;
      },
      updateAuthInProgress(state, vlu) {
         state.authInProgress = vlu;
      },
      addToCart(state, vlu) {
         state.cart.push(vlu)
         sessionStorage.setItem("link-cart", JSON.stringify(state.cart));
      },
      clearCart(state, vlu) {
         state.cart = []
         sessionStorage.setItem("link-cart", JSON.stringify(state.cart));
      },
      setInternalAdmin(state, internalAdmin) {
         localStorage.setItem("internalAdmin", JSON.stringify(internalAdmin));
         state.internalAdmin = internalAdmin;
      },
   },
   actions: {
      async getAnnouncements({ commit }) {
         let html = "";
         await axios
            .get(process.env.BASE_URL + "announce.json")
            .then(response => {
               commit("updateAnnounce", response.data.announcementHtml);
            })
            .catch(err => {}); // do nothing if missing
      },
      async getHierarchies({ commit }) {
         if (this.state.appUser) {
            var payload = {
               userId: this.state.appUser.userId,
               roleCode: this.state.appUser.userRoleCode
            };
            await Vue.prototype.$agent
               .getHierarchies(payload)
               .then(response => {
                  commit("updateHierarchies", response.hierarchyItems);
               });
         }
      },
      async getPendingReports({ commit }) {
         // dont ask for it if they arent logged in
         if (this.state.checkPendingReports &&
             this.state.userClaims && 
             this.state.appUser.userId != '' && 
             this.state.appUser.userId != null
         ) {
            await Vue.prototype.$reports.getPendingCount()
               .then(resp => {
                  commit('updatePendingReports', resp)
               })
               .catch((err) => {
                  // log err
               })
         }
      },

   }
});
